import styled from 'styled-components';
import { tokens } from '../../public/tokens';

const { colors, typography, globals } = tokens;

/**
 * Horizontal rule with its label sitting in the gap, e.g. an "or" between two
 * alternative actions.
 */
export const Divider = styled.div({
    display: 'flex',
    alignItems: 'center',
    gap: globals['spacing-sm'],
    width: '100%',
    color: colors.text.disabled,
    fontSize: typography.fontSize['md-12px'],

    '::before, ::after': {
        content: '""',
        flex: 1,
        height: '1px',
        background: colors.surfaces['border-divider'],
    },
});
